import { LOG_EVENT_TYPES } from 'src/logger/event-types';
import { LOG_LEVEL } from 'src/logger/log-level';
import {
    recordRumEvent,
    setRumSessionAttributes,
} from 'src/utils/cloudwatch-rum';

/**
 * Resolve which RUM custom event type (if any) to emit for a log record.
 * Debug never goes remote. Info/warn only when an explicit eventType is set.
 * Errors always eligible (catalogued type or generic LOG_ERROR).
 *
 * @param {Object} record
 * @returns {string|null}
 */
const resolveRumEventType = (record) => {
    if (!record || record.level === LOG_LEVEL.DEBUG) {
        return null;
    }

    if (record.eventType) {
        return record.eventType;
    }

    if (record.level === LOG_LEVEL.ERROR) {
        return LOG_EVENT_TYPES.LOG_ERROR;
    }

    return null;
};

/**
 * CloudWatch RUM remote transport. No-op when RUM is not initialized.
 *
 * @returns {{ log: Function, setContext: Function }}
 */
export const createRumTransport = () => ({
    log(record) {
        const eventType = resolveRumEventType(record);
        if (!eventType) {
            return;
        }

        recordRumEvent(eventType, {
            message: record.message,
            level: record.level,
            ...(record.meta || {}),
        });
    },

    setContext(attributes = {}) {
        setRumSessionAttributes(attributes);
    },
});
